var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"uploadFileInput",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"input":_vm.onInputChanged}})
}
var staticRenderFns = []

export { render, staticRenderFns }